import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  individualsService,
  Individual,
  TerminateIndividualRequest,
} from '@aslanpay/portal-common-lib';

const useTerminateIndividual = ({
  onSuccess,
  onError,
}: UseMutationOptions<Individual, Error, TerminateIndividualRequest>) => {
  return useMutation<Individual, Error, TerminateIndividualRequest>(
    ({ id, terminationDate }: TerminateIndividualRequest) =>
      individualsService.terminateIndividual({
        id,
        terminationDate,
      }),
    { onSuccess, onError }
  );
};

export default useTerminateIndividual;
